import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@noor/lib/cn';

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        // Type resolves through `--form-label-*` sizing handles so every label
        // (field labels, option labels, filter captions) retunes from one place.
        'flex items-center gap-2 text-[length:var(--form-label-font-size)] leading-normal font-[var(--form-label-font-weight)] tracking-[var(--form-label-tracking)] text-form-label-fg select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-form-control-fg-disabled peer-disabled:cursor-not-allowed peer-disabled:text-form-control-fg-disabled',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
